import 'src/assets/styles/declarations/font-faces.css';
import 'src/assets/styles/declarations/_index.module.scss';

import { history, persistor, store, useAppDispatch } from 'src/redux/store';

import { ApolloProvider } from '@apollo/client';
import App from './App';
import { ApplicationContextProvider } from 'src/contexts/ApplicationContext';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { client } from 'src/apollo-client';
import mapboxgl from 'mapbox-gl';

// Bugfix for: https://github.com/mapbox/mapbox-gl-js/issues/10173
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-var-requires
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

function WithApollo() {
  const dispatch = useAppDispatch();

  return (
    <ApolloProvider client={client(dispatch)}>
      <ConnectedRouter history={history}>
        <ApplicationContextProvider>
          <App />
        </ApplicationContextProvider>
      </ConnectedRouter>
    </ApolloProvider>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <WithApollo />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('app-root'),
);
